import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { IportalHomeComponent } from './iportal-home/iportal-home.component';

import { MsalGuard } from '@azure/msal-angular';
import { AdminGuard } from './_guard/admin.guard';

import { DashboardComponent } from './dashboard/dashboard.component';
import { NotRegisteredComponent } from './not-registered/not-registered.component';
import { CompaniesComponent } from './dashboard/companies/companies.component';
import { VesselsComponent } from './dashboard/vessels/vessels.component';
import { CompanyDetailComponent } from './dashboard/companies/company-detail/company-detail.component';
import { CompanyEditComponent } from './dashboard/companies/company-edit/company-edit.component';
import { CompanyRegisterComponent } from './dashboard/companies/company-register/company-register.component';
import { CompanyListComponent } from './dashboard/companies/company-list/company-list.component';
import { UserComponent } from './dashboard/user/user.component';
import { UserListComponent } from './dashboard/user/user-list/user-list.component';
import { UserPreviewComponent } from './dashboard/user/user-preview/user-preview.component';
import { UserRegisterComponent } from './dashboard/user/user-register/user-register.component';
import { UserEditComponent } from './dashboard/user/user-edit/user-edit.component';
import { VesselDetailComponent } from './dashboard/vessels/vessel-detail/vessel-detail.component';
import { VesselEditComponent } from './dashboard/vessels/vessel-edit/vessel-edit.component';
import { VesselRegisterComponent } from './dashboard/vessels/vessel-register/vessel-register.component';
import { VesselListComponent } from './dashboard/vessels/vessel-list/vessel-list.component';
import { VesselApplicationRegisterComponent } from './dashboard/vessels/vessel-application-register/vessel-application-register.component';
import { TenantsComponent } from './dashboard/tenants/tenants.component';
import { TenantListComponent } from './dashboard/tenants/tenant-list/tenant-list.component';
import { TenantEditComponent } from './dashboard/tenants/tenant-edit/tenant-edit.component';
import { TenantRegisterComponent } from './dashboard/tenants/tenant-register/tenant-register.component';
import { MeetingsComponent } from './dashboard/meetings/meetings.component';
import { JoinComponent } from './dashboard/meetings/join/join.component';
import { RoomComponent } from './dashboard/meetings/room/room.component';
import { ClaimCenterComponent } from './dashboard/claim-center/claim-center.component';
import { ClaimEditComponent } from './dashboard/claim-center/claim-edit/claim-edit.component';
import { InquiryCenterComponent } from './dashboard/inquiry-center/inquiry-center.component';
import { InquiryEditComponent } from './dashboard/inquiry-center/inquiry-edit/inquiry-edit.component';

const routes: Routes = [
  {path: 'home', component: IportalHomeComponent},
  {path: 'dashboard', component: DashboardComponent, canActivate: [MsalGuard], canActivateChild: [AdminGuard], children: [
    {path: 'company', component: CompaniesComponent, canActivate: [MsalGuard], children: [
      {path: 'company-detail/:id', component: CompanyDetailComponent, canActivate: [MsalGuard]},
      {path: 'company-register', component: CompanyRegisterComponent, canActivate: [MsalGuard]},
      {path: 'company-edit/:id', component: CompanyEditComponent, canActivate: [MsalGuard]},
      {path: 'company-list', component: CompanyListComponent, canActivate: [MsalGuard]}
    ]},
    {path: 'vessel', component: VesselsComponent, canActivate: [MsalGuard], children: [
      {path: 'vessel-detail/:id', component: VesselDetailComponent, canActivate: [MsalGuard]},
      {path: 'vessel-register', component: VesselRegisterComponent, canActivate: [MsalGuard]},
      {path: 'vessel-list', component: VesselListComponent, canActivate: [MsalGuard]},
      {path: 'vessel-edit/:id', component: VesselEditComponent, canActivate: [MsalGuard]},
      {path: 'vessel-application-register', component: VesselApplicationRegisterComponent, canActivate: [MsalGuard]},
    ]},
    {path: 'user', component: UserComponent, canActivate: [MsalGuard], children: [
      {path: 'user-list', component: UserListComponent, canActivate: [MsalGuard]},
      {path: 'user-preview/:id', component: UserPreviewComponent, canActivate: [MsalGuard]},
      {path: 'user-edit/:id', component: UserEditComponent, canActivate: [MsalGuard]},
    ]},
    {path: 'tenant', component: TenantsComponent, canActivate: [MsalGuard], children: [
      {path: 'tenant-list', component: TenantListComponent, canActivate: [MsalGuard]},
      {path: 'tenant-edit', component: TenantEditComponent, canActivate: [MsalGuard]},
      {path: 'tenant-register', component: TenantRegisterComponent, canActivate: [MsalGuard]},
    ]},
    {path: 'meetings', canActivate: [MsalGuard], children: [
      {path: 'calendar', component: MeetingsComponent, canActivate: [MsalGuard]},
      {path: 'join-a-room', component: JoinComponent, canActivate: [MsalGuard]},
      {path: 'room/:name', component: RoomComponent, canActivate: [MsalGuard]},
    ]},
    {path: 'claim-center', canActivate: [MsalGuard], children: [
      {path: 'dashboard', component: ClaimCenterComponent, canActivate: [MsalGuard]},
      {path: 'claim-edit/:readableId', component: ClaimEditComponent, canActivate: [MsalGuard]},
    ]},
    {path: 'inquiry-center', canActivate: [MsalGuard], children: [
      {path: 'dashboard', component: InquiryCenterComponent, canActivate: [MsalGuard]},
      {path: 'inquiry-edit/:readableId', component: InquiryEditComponent, canActivate: [MsalGuard]},
    ]},
  ]},
  { path: '', redirectTo: '/dashboard/claim-center/dashboard', pathMatch: 'full' },
  {path: 'dashboard/company/company-registration', component: CompanyRegisterComponent, canActivate: [MsalGuard]},
  {path: 'dashboard/user/user-registration', component: UserRegisterComponent, canActivate: [MsalGuard]},
  {path: 'dashboard/vessel/vessel-registration', component: VesselRegisterComponent, canActivate: [MsalGuard]},
  {path: 'dashboard/tenant/tenant-registration', component: TenantRegisterComponent, canActivate: [MsalGuard]},
  {path: 'not-registered', component: NotRegisteredComponent}
];
Option
const isIframe = window != window.parent && !window.opener;
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled', // Don't perform initial navigation in iframes
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'top',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
